<template>
  <div :class="inputClass">
    <b-button class="card-header" size="sm" variant="light" v-b-toggle="'legendBody'">
      <slot name="header"></slot>
    </b-button>
    <b-collapse visible id="legendBody">
      <b-card-body>
        <slot name="body"></slot>
      </b-card-body>
    </b-collapse>
  </div>
</template>

<script>
export default {
  name: "MapComponent",
  props: {
    inputClass: String
  },
  onAdd(map){

  },
  onRemove() {

  }
}
</script>

<style lang="css" scoped>
  .overlay-tr {
    position: absolute;
    top: 15px;
    right: 2em;
    padding: 2px;
  }
</style>
